import PageSuspense from '@/components/UI/PageSuspense';
import { Results } from '@/pages/(guarded)/results/components/ResultsWrapper';

export default ArchivePage;

// Main component
function ArchivePage() {
  return (
    <PageSuspense>
      <Results title="All Results" userId="archive" baseUrl="/archive" />
    </PageSuspense>
  );
}
